import { API } from "aws-amplify";
import { updateBackgroundCheck } from "~/graphql/mutations";
import * as APITypes from "~/API";
import { LoaderData } from "~/types";
import { EMPTY_BACKGROUND_CHECK_INFO } from "../getLeaseInfo/getBackgroundCheckInfo";

export const editBackgroundCheck = async (
  payload: APITypes.UpdateBackgroundCheckInput
): Promise<LoaderData<APITypes.BackgroundCheck>> => {
  try {
    const response = (await API.graphql({
      query: updateBackgroundCheck,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.UpdateBackgroundCheckMutation };

    return {
      success: true,
      data: response.data?.updateBackgroundCheck || EMPTY_BACKGROUND_CHECK_INFO,
    };
  } catch (error) {
    console.error("Error editing background check", error);
    return {
      success: false,
      data: EMPTY_BACKGROUND_CHECK_INFO,
      error,
    };
  }
};
